/**
 * @typedef {import('../types/token').Token} Token
 * @typedef {import('../types/chunk').Chunk} Chunk
 */

/**
 * Build an array of chunk objects from tokens and chunking parameters.
 * @param {Token[]} tokens - Array of token objects.
 * @param {number} windowSize - Window size for each chunk.
 * @param {number} overlap - Overlap between chunks.
 * @returns {Chunk[]} Array of chunk objects.
 */
export function buildChunks(tokens, windowSize, overlap) {
  if (!Array.isArray(tokens)) {
    throw new Error("buildChunks: tokens must be an array");
  }
  const chunks = [];
  let i = 0;
  let chunkID = 0;
  while (i < tokens.length) {
    const chunkTokens = tokens.slice(i, i + windowSize);
    if (chunkTokens.length === 0) {
      break;
    }
    // If the remaining tokens are less than the window size, still create a chunk
    const chunkText = chunkTokens.map((t) => t.text).join("");
    // Label is the tokens newly exposed in this window (difference between window and overlap)
    const labelLength = Math.max(1, windowSize - overlap);
    const labelTokens = chunkTokens.slice(0, labelLength);
    const chunkLabel = labelTokens.map((t) => t.text).join("");
    chunks.push({
      chunkID,
      chunkText,
      chunkTokens,
      chunkWindowSize: windowSize,
      chunkEmbedding: null, // Will be set later
      chunkEmbeddingReduced: null, // Will be set later
      chunkLabel,
    });
    // If we just created a final partial chunk, break
    if (chunkTokens.length < windowSize) {
      break;
    }
    i += windowSize - overlap;
    chunkID++;
  }
  return chunks;
}
